'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _Context = require('../Context/Context');

var _Context2 = _interopRequireDefault(_Context);

var _ContextMenuItem = require('../Context/ContextMenuItem');

var _DropdownReactContext = require('./DropdownReactContext');

var _DropdownReactContext2 = _interopRequireDefault(_DropdownReactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof window !== 'undefined') {
  require('element-closest');
}

var isFocusableMenuItem = function isFocusableMenuItem(element) {
  return element && element.hasAttribute(_ContextMenuItem.contextMenuItemSelector) && !element.disabled;
};

/* eslint-disable react/no-find-dom-node */

var DropdownContext = function (_Component) {
  _inherits(DropdownContext, _Component);

  function DropdownContext(props) {
    _classCallCheck(this, DropdownContext);

    var _this = _possibleConstructorReturn(this, (DropdownContext.__proto__ || Object.getPrototypeOf(DropdownContext)).call(this, props));

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    return _this;
  }

  _createClass(DropdownContext, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('mousedown', this.handleClick);
      document.removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClick);
      document.addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      if (!this.context.dropdownRef || !this.context.closeDropdown) {
        return;
      }

      var dropdownRef = this.context.dropdownRef();
      if (dropdownRef && !dropdownRef.contains(event.target) && !this.el.contains(event.target)) {
        return this.context.closeDropdown();
      }
    }
  }, {
    key: 'getFocusedMenuItem',
    value: function getFocusedMenuItem() {
      return this.el.querySelector('[' + _ContextMenuItem.contextMenuItemSelector + ']:focus');
    }
  }, {
    key: 'getMenuItems',
    value: function getMenuItems() {
      return [].concat(_toConsumableArray(this.el.querySelectorAll('[' + _ContextMenuItem.contextMenuItemSelector + ']:not(:disabled)')));
    }
  }, {
    key: 'focusMenuItem',
    value: function focusMenuItem(element) {
      var menuItem = element.closest('[' + _ContextMenuItem.contextMenuItemSelector + ']');

      if (menuItem && isFocusableMenuItem(menuItem)) {
        menuItem.focus();
      }
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      this.focusMenuItem(event.target);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          return this.handleDirectionKey('nextElementSibling', 1);
        case 'ArrowUp':
          event.preventDefault();
          return this.handleDirectionKey('previousElementSibling', -1);
        case 'Tab':
        case 'Escape':
          event.preventDefault();
          return this.context.closeDropdown();
      }
    }
  }, {
    key: 'handleDirectionKey',
    value: function handleDirectionKey(sibling, delta) {
      var focusedMenuItem = this.getFocusedMenuItem();
      var siblingElement = focusedMenuItem && isFocusableMenuItem(focusedMenuItem[sibling]) ? focusedMenuItem[sibling] : null;

      if (siblingElement) {
        return siblingElement.focus();
      }

      var menuItems = this.getMenuItems();
      var index = focusedMenuItem && menuItems.indexOf(focusedMenuItem);

      if (focusedMenuItem && menuItems[index + delta]) {
        return menuItems[index + delta].focus();
      } else if (!focusedMenuItem && menuItems.length > 0) {
        menuItems[0].focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_Context2.default, _extends({}, (0, _lodash2.default)(this.props, ['focusOnOpen', 'onRequestCloseDropdown']), {
        ref: function ref(el) {
          return _this2.el = _reactDom2.default.findDOMNode(el);
        } }));
    }
  }]);

  return DropdownContext;
}(_react.Component);

DropdownContext.propTypes = {
  /** React reference function for the arrow element */
  arrowRef: _propTypes2.default.func,
  /** Content to be inserted in the contextual area */
  children: _propTypes2.default.node,
  /** Color of the Context */
  color: _propTypes2.default.oneOf(['success', 'warning', 'error', 'info']),
  /** Maximum height for the content area, exceeding this will make it scrollable */
  maxHeight: _propTypes2.default.string,
  /** Position of the content area relative to the arrow */
  position: _propTypes2.default.oneOf(['top', 'bottom', 'right', 'left']),
  /** Total width of the component */
  width: _propTypes2.default.string
};
DropdownContext.defaultProps = {
  maxHeight: '30rem',
  position: 'top',
  width: '14.5rem'
};
DropdownContext.contextType = _DropdownReactContext2.default;
exports.default = DropdownContext;